var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconJavascript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8203 0.864258H0.0478516V27.6367H26.8203V0.864258ZM9.13603 21.9973L7.08731 23.2372C7.68039 24.4952 8.84854 25.5373 10.8612 25.5373C13.0898 25.5373 14.6173 24.3512 14.6173 21.7454V13.1554H12.1014V21.7098C12.1014 22.9677 11.5801 23.2911 10.7534 23.2911C9.89089 23.2911 9.53134 22.6981 9.13603 21.9973ZM18.0323 21.7816L15.9838 22.9676C16.7206 24.4234 18.2301 25.5377 20.5663 25.5377C22.9564 25.5377 24.7356 24.2978 24.7356 22.0332C24.7356 19.9307 23.5315 18.9963 21.3929 18.0797L20.7639 17.8102C19.6857 17.3429 19.2185 17.0372 19.2185 16.2825C19.2185 15.6715 19.6857 15.2042 20.4226 15.2042C21.1415 15.2042 21.6085 15.5097 22.0399 16.2825L23.9989 15.0244C23.1723 13.5687 22.0221 13.0115 20.4227 13.0115C18.1762 13.0115 16.7386 14.4493 16.7386 16.3363C16.7386 18.385 17.9426 19.3555 19.7578 20.1281L20.3866 20.3979C21.5368 20.9009 22.2197 21.2065 22.2197 22.0691C22.2197 22.7879 21.555 23.3092 20.5124 23.3092C19.2725 23.3092 18.5716 22.6622 18.0323 21.7816Z",
    className: "icon-primary-color"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJavascript);
export default __webpack_public_path__ + "static/media/icon-javascript.ad3c37105bce1e7b1ed0a43d91375574.svg";
export { ForwardRef as ReactComponent };